import styled from '@emotion/styled';
import { Button, Typography } from '@mgmresorts/mgm-ui';

export const StyledContent = styled.div``;

export const StyledAlertContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;

export const StyledHeading = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  padding-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.semantic.HeadingMedium2.fontSize}px;
  }
`;

export const StyledInputContainer = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;

export const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;

export const StyledLink = styled(Button)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;
